import { USER_MENU } from "./constants";

export const getMenu = (menu_type,user_tp) => {

    const menu = USER_MENU[user_tp][menu_type];

    const main = menu.filter((item,index)=>item.TYPE==='MAIN');
    const sub = menu.filter((item,index)=>item.TYPE==='SUB');

    return {main,sub}

}